import { load, save } from "./storage";

const createDefaultState = () => ({ screens: {}, current: null });

const normalizeState = (value) => {
  if (!value || typeof value !== "object") return createDefaultState();
  return {
    screens: value.screens && typeof value.screens === "object" ? value.screens : {},
    current: typeof value.current === "string" || value.current === null ? value.current : null,
  };
};

let state = normalizeState(load());
let subs = [];
const SCREEN_DEFAULT = { form: {}, list: [], filters: {}, editId: null, errors: {}, dynamicOptions: {} };
const SHOP_KEY = "products";
const ADMIN_KEYS = ["adminProducts", "adminproducts"];

const ensureScreen = (name) => {
  if (!state.screens[name]) state.screens[name] = { ...SCREEN_DEFAULT };
  return state.screens[name];
};

const firstNonEmptyList = (keys) => {
  for (const key of keys) {
    const list = state.screens[key]?.list;
    if (Array.isArray(list) && list.length > 0) return list;
  }
  return [];
};

/* ===== SWITCH SCREEN ===== */
export const setScreen = (name) => {
  state = normalizeState(state);
  state.current = name;
  ensureScreen(name);

  const shopScreen = ensureScreen(SHOP_KEY);
  const adminList = firstNonEmptyList(ADMIN_KEYS);
  if ((!shopScreen.list || shopScreen.list.length === 0) && adminList.length > 0) {
    state.screens[SHOP_KEY] = { ...shopScreen, list: adminList };
  }

  const shopList = state.screens[SHOP_KEY]?.list;
  if (Array.isArray(shopList) && shopList.length > 0) {
    ADMIN_KEYS.forEach((key) => {
      const adminScreen = ensureScreen(key);
      if (!Array.isArray(adminScreen.list) || adminScreen.list.length === 0) {
        state.screens[key] = { ...adminScreen, list: shopList };
      }
    });
  }
  notify();
};

/* ===== GET CURRENT SCREEN STATE ===== */
export const getS = () => {
  if (!state.current) return {};
  return state.screens[state.current] || {};
};

/* ===== GET ANY SCREEN STATE ===== */
export const getScreen = (name) => state.screens[name] || {};

/* ===== SET CURRENT SCREEN STATE (shallow merge) ===== */
export const setS = (data) => {
  if (!state.current) return;
  const cur = state.screens[state.current] || {};
  state.screens[state.current] = { ...cur, ...data };
  save(state);
  notify();
};

/* ===== BROADCAST LIST TO ALL SCREENS ===== */
export const broadcastList = (list) => {
  const targets = new Set([...Object.keys(state.screens), SHOP_KEY, ...ADMIN_KEYS]);
  targets.forEach((screen) => {
    const current = state.screens[screen] || { ...SCREEN_DEFAULT };
    state.screens[screen] = { ...current, list };
  });
  save(state);
  notify();
};

/* ===== CLEAR SESSION-SCOPED UI DATA ===== */
export const clearSessionScopedUI = () => {
  const targets = Object.keys(state.screens || {});
  targets.forEach((screen) => {
    const cur = state.screens[screen] || { ...SCREEN_DEFAULT };
    state.screens[screen] = {
      ...cur,
      form: {},
      filters: {},
      errors: {},
      editId: null,
    };
  });
  save(state);
  notify();
};

/* ===== SUBSCRIBE ===== */
export const sub = (fn) => {
  subs.push(fn);
  return () => { subs = subs.filter((s) => s !== fn); };
};

const notify = () => subs.forEach((f) => f());
